import React, { useState, useEffect } from 'react'
import expiredLogo from '../../../public/ExpiredCards.svg'
import bdLogo from '../../../public/Bitmap.png'

const roomJson = require('../../../rooms.json')

export default function SubscriptionExpired({ customerId }) {
  const [loading, setLoading] = useState(true)
  const [checkoutUrl, setCheckoutUrl] = useState('')

  sessionStorage.setItem('cachedCustomerId', `${customerId}`)
  sessionStorage.setItem('cachedRoomUrl', `${window.location.href}`)


  function getRoomName() {
    const roomName = window.location.pathname
      .split('/')
      .filter(function (el) {
        return el !== ''
      })
      .pop()

    return roomName ? roomName : 'local'
  }

  function getRoomKey() {
    let roomName = getRoomName();
    let roomObj = roomJson.filter(obj => {
      return obj.room_name === roomName
    })

    const roomKey = roomObj[0].key
    sessionStorage.setItem('cachedRoomKey', roomKey)
  }

  const roomUrl = `${window.location.href}`

  async function createStripeSession() {
    const roomKey = sessionStorage.getItem('cachedRoomKey');

    var myHeaders = new Headers()
    myHeaders.append(
      'Authorization',
      `Bearer ${process.env.REACT_APP_STRIPE_SECRET_LIVE}`
    )
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

    var urlencoded = new URLSearchParams()
    urlencoded.append('success_url', `${window.location.origin}/renew-success`)
    urlencoded.append('cancel_url', `${window.location.href}`)
    urlencoded.append('line_items[0][price]', 'price_1Hr6mJLTZmj0aAlElRVUPFOz')
    urlencoded.append('line_items[0][quantity]', '1')
    urlencoded.append('mode', 'subscription')
    urlencoded.append('customer', customerId)
    urlencoded.append('subscription_data[metadata][subscription_renewal]', true)
    urlencoded.append('subscription_data[metadata][room_url]', roomUrl)
    urlencoded.append('subscription_data[metadata][room_key]', roomKey)

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow',
    }

    fetch('https://api.stripe.com/v1/checkout/sessions', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        setCheckoutUrl(JSON.parse(result).url)
        setLoading(false)
      })
      .catch((error) => console.log('error', error))
  }

  useEffect(() => {
    // We need to delete existing payment info before we let people renew to maintain security
    // https://stripe.com/docs/api/payment_methods/list
    getRoomKey();

    async function getPaymentid() {
      const url = `https://api.stripe.com/v1/payment_methods?customer=${customerId}&type=card`
      const options = {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_LIVE}`,
        },
      }
      let response = await fetch(url, options)

      try {
        response = await response.json()
        // the above api call returns the id of the stripe payment method
        return response.data[0].id
      } catch (error) {
        console.log(error)
      }
    }

    async function removePaymentInfo() {
      // we need to get the payment method id so that we can remove it before we show the renewal flow
      // https://stripe.com/docs/api/payment_methods/detach
      const id = await getPaymentid()
      const url = `https://api.stripe.com/v1/payment_methods/${id}/detach`
      const options = {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_LIVE}`,
        },
      }

      try {
        let response = await fetch(url, options)
      } catch (error) {
        console.log(error)
      }
    }

    removePaymentInfo()
    createStripeSession(customerId)
  }, [])

  // We don't want to show the subscribe button until our calls finish so we tie in a loading state
  let button
  if (loading) {
    button = <button className='subscription-expired-button'>Loading...</button>
  } else {
    button = (
      <a href={checkoutUrl}>
        <button className='subscription-expired-button'>Reactivate</button>
      </a>
    )
  }


  return (
    <div className='subscription-expired-container'>
      <div className='nav-bar'>
        <a
          href='https://branding.cards'
          alt='bd-logo'
          className='bd-logo-container'
        >
          <img className='bd-logo' src={bdLogo} alt='Brand Deck Logo' />
        </a>
        <div className='back-link-container'>
          <a className='back-link' href='https://branding.cards'>
            Back to Branding.Cards
          </a>
        </div>
      </div>
      <div className='subscription-expired-render'>
        <div className='subscription-expired-header'>Subscription Expired</div>
        <div className='subscription-expired-image'>
          <img src={expiredLogo} alt='ExpiredLogos' />
        </div>
        <div className='subscription-expired-text'>
          <div>
            This room is no longer accessible because the subscription has
            expired.
          </div>
          <div className='my-1'>
            Questions? Need help?{' '}
            <a className='bd-link' href='mailto:hello@branding.cards'>
              Get in touch
            </a>
          </div>
          <div className='subscription-expired-button-container'>{button}</div>
        </div>
      </div>
    </div>
  )
}

// const [billingPortalUrl, setBillingPortalUrl] = useState('')
// const stripeKey =
//   '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'

// useEffect(() => {

// function stripeCustomerPortal() {
//   let myHeaders = new Headers()
//   myHeaders.append('Authorization', `Bearer ${stripeKey}`)
//   myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')
//   let urlencoded = new URLSearchParams()
//   urlencoded.append('customer', `${customerId}`)
//   urlencoded.append('return_url', 'https://app.branding.cards')
//   let requestOptions = {
//     method: 'POST',
//     headers: myHeaders,
//     body: urlencoded,
//     redirect: 'follow',
//   }
//   let billingUrl
//   fetch('https://api.stripe.com/v1/billing_portal/sessions', requestOptions)
//     .then((response) => response.json())
//     .then((result) => (billingUrl = result.url))
//     .then(() => console.log(billingUrl))
//     .then(() => setBillingPortalUrl(billingUrl))
//     .catch((error) => console.log('error', error))
// }
// stripeCustomerPortal()
// }, [])
